module.exports = __webpack_public_path__ + "img/Expo_Topic2.40c0cc38.png";